// removed by extract-text-webpack-plugin
module.exports = {"theme":"#5867FE"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/stylesheet/element-variables.scss
// module id = du+B
// module chunks = 52